import {Component, Input} from '@angular/core';
import {Address} from "@flowmaps-com/flowmaps-typescriptmodels";

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent {
  @Input() address: Address;
  @Input() readOnly = false;
  @Input() collapseGeoLocation = false;
  showGeoLocation = false;
  editGeoLocation = false;

  upperCase = (value: string): string => value ? value.toUpperCase() : value;

  showGeoLocationFields = (editable = false) => {
    this.showGeoLocation = true;
    this.editGeoLocation = editable;
  };
}
